
import './styles.scss'; //build the styles in scss and then compile to css.
import './tab-group.js';